module.exports = __webpack_public_path__ + "img/business2_E.54fa357b.png";